$(window).on('js-onload', function(){

    $('#promo-code').promotion();

    $(window)
        .on('applied.promo', function(event, discount, code){
            // create new row markup
            var newRow = Handlebars.templates['tfoot_row']({
                id: 'discount-row',
                label: 'Discount',
                labelPrepend: '<b>' + code + '</b> ',
                value: discount,
                displayValue: '- $' + discount.toFixed(2)
            });

            var $tfoot = $('.cart-table:first > tfoot:first');
            var $discountRow = $tfoot.find('> #discount-row:first');

            // replace or add markup
            if($discountRow.length > 0) {
                $discountRow.replaceWith(newRow);
            } else {
                $tfoot.find('.subtotal-row:first').after(newRow);
            }

            var address = activeShippingAddress();
            loadShippingMethods(address, 0);
        })
        .on('removed.promo', function(event){
            $('.cart-table:first > tfoot:first > #discount-row:first').remove();

            var address = activeShippingAddress();
            loadShippingMethods(address, 0);
        });
});